import { useMutation, useQueryClient } from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import {
  CreateApprovedDTO,
  WithdrawApiService,
} from 'features/withdraw/api/withdraw-api.service';

import { withdrawQueryKeys } from './query-keys';
const { createReject } = WithdrawApiService();
// ../api/withdraw-api.service
export const useCreateReject = () => {
  const { message } = App.useApp();
  const queryClient = useQueryClient();

  return useMutation(
    (payload: CreateApprovedDTO) => {
      return createReject(payload);
    },
    {
      onError: (error) => {
        const uiMessage = handleError(error);

        message.error(uiMessage);
      },
      onSuccess: () => {
        // TODO: invalidate week view endpoint as well, when ready
        queryClient.invalidateQueries({
          queryKey: withdrawQueryKeys.all,
        });

        message.success('Rejected successfully');
      },
    },
  );
};
